import { createFileRoute } from '@tanstack/react-router'

import BetaSection from 'pages/Settings/BetaSection'

export const Route = createFileRoute('/_auth/settings/beta')({
  component: BetaSection,
})
